import { createRoot } from 'react-dom/client'

import App from './App'
import { init } from '@sentry/react'

import './main.css'
import config from './config'

if (config.env != 'local') {
    init({
        environment: config.env,
        dsn: 'https://d8d21293fcdb4449a5802d960b9a2ec3@o347535.ingest.sentry.io/6718745',
    })
}

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)
root.render(<App />)
